import { Controller } from "@hotwired/stimulus"

// Cookie consent banner. Two-button (Accept / Decline) following the
// classic IAB pattern. Stores the decision in localStorage so the
// banner doesn't reappear, and dispatches a "consent:granted" or
// "consent:declined" event that the analytics loaders listen for.
//
// Analytics scripts (Clarity, HubSpot) are kept dormant in the page
// until consent is granted — they read the `data-consent="granted"`
// attribute on <html> on boot, and re-check on the event.
const KEY = "pcp_cookie_consent"   // "granted" | "declined"

export default class extends Controller {
  static targets = ["banner"]

  connect() {
    const stored = this._read()
    if (stored) {
      this._apply(stored)
      this.element.hidden = true
    } else {
      this.element.hidden = false
    }
  }

  accept() {
    this._write("granted")
    this._apply("granted")
    this.element.hidden = true
    document.dispatchEvent(new CustomEvent("consent:granted"))
  }

  decline() {
    this._write("declined")
    this._apply("declined")
    this.element.hidden = true
    document.dispatchEvent(new CustomEvent("consent:declined"))
  }

  _read()  { try { return localStorage.getItem(KEY) } catch (_) { return null } }
  _write(v){ try { localStorage.setItem(KEY, v) } catch (_) {} }
  _apply(v){ document.documentElement.setAttribute("data-consent", v) }
}
